module.exports = __webpack_public_path__ + "img/recharge-tipping.926b2c72.png";